import { render } from '../../core/shell.js';
import { S, save } from '../../core/store.js';
import { lockInModal } from '../projects/create.js';

// Drag a deal between pipeline stages. Dropping on Won offers to lock the deal in as a project.
export function initDealDnd() {
  let dragDeal = null;
  const col = (e) => e.target.closest && e.target.closest('[data-col]');
  document.addEventListener('dragstart', (e) => {
    const t = e.target.closest && e.target.closest('[data-deal]');
    if (!t) return;
    dragDeal = t.dataset.deal;
    try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', 'x'); } catch (x) { /* some browsers block this */ }
  });
  document.addEventListener('dragover', (e) => { const c = col(e); if (c && dragDeal) { e.preventDefault(); c.classList.add('over'); } });
  document.addEventListener('dragleave', (e) => { const c = col(e); if (c) c.classList.remove('over'); });
  document.addEventListener('drop', (e) => {
    const c = col(e);
    if (!c || !dragDeal) return;
    e.preventDefault();
    const d = S.deals.find((x) => x.id === dragDeal);
    dragDeal = null;
    if (!d) return;
    const was = d.stage;
    d.stage = c.dataset.col;
    save(); render();
    if (d.stage === 'won' && was !== 'won' && !d.pid) lockInModal(d);
  });
  document.addEventListener('dragend', () => { dragDeal = null; document.querySelectorAll('[data-col].over').forEach((x) => x.classList.remove('over')); });
}
